import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "center content-box"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }

import { useRoute } from "vue-router";
import { ref } from "vue";
import { FlightModel } from "@/models/flight.model";
import { FlightService } from "@/services/flight.service";


export default /*@__PURE__*/_defineComponent({
  __name: 'FlightView',
  setup(__props) {

const route = useRoute()
const id = Number(route.params.id)
const error = ref<string>()
const flight = ref<FlightModel>()

FlightService.getFlightById(id)
    .then(rsp => flight.value = rsp.data)
    .catch(e => error.value = e.message)

function getDestinationImageUrl(dest: string) {
    return 'https://img.pequla.com/destination/' + dest.toLowerCase().split(' ')[0] + '.jpg';
}

return (_ctx: any,_cache: any) => {
  return (flight.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h3", null, _toDisplayString(flight.value.destination) + " (" + _toDisplayString(flight.value.flightNumber) + ")", 1),
        _createElementVNode("p", null, [
          _createElementVNode("img", {
            src: getDestinationImageUrl(flight.value.destination),
            width: "960"
          }, null, 8, _hoisted_2)
        ]),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, "International code: " + _toDisplayString(flight.value.flightKey), 1),
          _createElementVNode("li", null, "Flight number: " + _toDisplayString(flight.value.flightNumber), 1),
          _createElementVNode("li", null, "Destination: " + _toDisplayString(flight.value.destination), 1),
          _createElementVNode("li", null, "Scheduled at: " + _toDisplayString(flight.value.scheduledAt), 1),
          _createElementVNode("li", null, "Plane model: " + _toDisplayString(flight.value.plane), 1),
          _createElementVNode("li", null, "Airport gate: " + _toDisplayString(flight.value.gate), 1),
          _createElementVNode("li", null, "Airport terminal: " + _toDisplayString(flight.value.terminal), 1)
        ])
      ]))
    : (error.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Error: " + _toDisplayString(error.value), 1))
      : (_openBlock(), _createElementBlock("p", _hoisted_4, "Loading... Please wait!"))
}
}

})